import { motion } from 'motion/react';
import PropTypes from 'prop-types';
import { useLoading } from '../hooks/useLoading';
import Heading from './Heading';

export default function Loading({ data, getLabel, predictedLoadTime }) {
	const { message, transitionKey } = useLoading(predictedLoadTime, getLabel);

	return (
		<div className="trial__loading">
			<Heading title={getLabel('loading_heading')} />
			<img className="loading__image" src={data.visuals.loading.full_url} alt={data.visuals.loading.alt} />
			<motion.p key={transitionKey} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 1 }}>
				{message}
			</motion.p>
		</div>
	);
}

Loading.propTypes = {
	data: PropTypes.object.isRequired,
	getLabel: PropTypes.func.isRequired,
	predictedLoadTime: PropTypes.number.isRequired,
};
